import React from "react";
import {
  Button,
  Checkbox,
  DialogActions,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { Add, Close, Delete } from "@material-ui/icons";
import { DayHour, dayHourRangesIsValid } from "./DayHour";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { useDialog } from "../Dialogs/DialogProvider";
import withIntl from "../../utils/withIntl";
import { days } from "./WeekHours";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  dialogActions: {
    justifyContent: "center",
  },
}));

function UpdateOpeningHourDialog(props) {
  const classes = useStyles();
  const day = props.day;
  const [openingHourRanges, setOpeningHourRanges] = React.useState(props.openingHourRanges);
  const [editDays, setEditDays] = React.useState(days.map((dayIterator) => dayIterator === day));
  const [, closeDialog] = useDialog();
  return (
    <>
      <DialogTitle id="simple-dialog-title">
        {props.intl.formatMessage({ id: day })}
        <IconButton onClick={() => closeDialog()} color="primary" style={{ position: "absolute", top: 8, right: 8 }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <List dense>
            {days.map((dayIterator, index) => {
              return (
                <ListItem dense style={{ padding: 0 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color={"primary"}
                        checked={editDays[index]}
                        key={index}
                        onChange={(e) => {
                          let newValues = [...editDays];
                          newValues[index] = e.target.checked;
                          setEditDays(newValues);
                        }}
                      />
                    }
                    label={props.intl.formatMessage({ id: dayIterator })}
                  />
                </ListItem>
              );
            })}
          </List>

          <Grid container style={{ textAlign: "center", width: "250px" }} justify={"center"} alignItems={"center"}>
            {openingHourRanges.length === 0 && (
              <Typography variant={"h6"}>{props.intl.formatMessage({ id: "closed" })}</Typography>
            )}
            {openingHourRanges.map((openingHourRange, index) => {
              return (
                <>
                  <Grid item xs={2}>
                    {/*<Typography>Van</Typography>*/}
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      inputProps={{ maxLength: 5 }}
                      value={openingHourRange.openingHour}
                      onChange={(e) => {
                        let value = e.target.value;
                        value = value.replace(/[^0-9\:]+/g, "");

                        openingHourRanges[index].openingHour = value;
                        setOpeningHourRanges([...openingHourRanges]);
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Typography>-</Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      inputProps={{ maxLength: 5 }}
                      value={openingHourRange.closingHour}
                      onChange={(e) => {
                        let value = e.target.value;
                        value = value.replace(/[^0-9\:]+/g, "");
                        openingHourRanges[index].closingHour = value;
                        setOpeningHourRanges([...openingHourRanges]);
                      }}
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <IconButton
                      onClick={() => {
                        let newHours = [...openingHourRanges];
                        newHours.splice(index, 1);
                        setOpeningHourRanges(newHours);
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Grid>
                </>
              );
            })}
            <Grid item xs={10} />
            <Grid item xs={2}>
              <IconButton
                onClick={() => {
                  let newHours = [...openingHourRanges];
                  newHours.push(new DayHour("00:00", "24:00"));
                  setOpeningHourRanges(newHours);
                }}
              >
                <Add />
              </IconButton>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        <Button
          variant={"outlined"}
          disabled={!dayHourRangesIsValid(openingHourRanges)}
          onClick={() => {
            props.onSave(openingHourRanges, editDays);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
}

export default withIntl(UpdateOpeningHourDialog);
